import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik, Form, FormikProvider } from "formik";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import {
  Box,
  Grid,
  Card,
  Container,
  Button,
  FormControl,
  InputLabel,
  TextField,
  Autocomplete,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import Loader from "src/components/Loader";
// @mui
import Page from "../../components/Page";
import { GetUserListAction } from "src/redux/actions/UsersAction";
import { getMatchList, getReportData, getReportDownload, getReportDownloadFiles, downloadReportFile, deleteAllFiles } from "src/redux/actions/ReportManagement";
import { UserListHead } from "./../../sections/@dashboard/user";
import Label from "./../../components/Label";
import Scrollbar from "./../../components/Scrollbar";
import { Download, Delete } from "@mui/icons-material";
import moment from "moment";

export default function ReportManagementList() {
  const today = new Date().toISOString().split("T")[0];
  let params1 = null;
  const dispatch = useDispatch();
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [open, setOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const formatFileSize = useCallback((size) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
    return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  }, []);

  //const UserList = useSelector((state) => state.users.user_list.data);
  const reportList = useSelector((state) => state?.reports);

  const MatchListData = useSelector((state) => state?.matches?.active_match_list?.data?.match_list || []);
  console.log("this is the match list data >>>", MatchListData);
  const UserList = useSelector((state) => state?.users?.user_list?.data);

  const USERLIST = (UserList !== undefined && UserList?.data?.users) || [];

  console.log("reportList--->>", reportList);
  let transDescrip = reportList?.report_list?.data?.transDes;

  const formik = useFormik({});

  const { errors, touched, getFieldProps } = formik;
  useEffect(() => {
    // if (Object.keys(createNotifySelector).length > 0) {
    //     if (createNotifySelector ?. status) {
    //         toast.success(createNotifySelector.message, {theme: "colored"})
    //         // navigate(`/dashboard/notification/list`)
    //         setAccessModuleArr([])
    //         dispatch(ResetCreateSubadminAction())
    //     } else {
    //         toast.error(createNotifySelector.message, {theme: "colored"})
    //         dispatch(ResetCreateSubadminAction())
    //     }
    // }
  }, []);

  const gameType = [
    {
      id: "cricket",
      type: "ckt",
      name: "Cricket",
      table_name: "upcomingcrickets",
    },
    {
      id: "ftbl",
      type: "fb",
      name: "Football",
      table_name: "fbupcomings",
    },
  ];

  const match_status = [
    {
      rstatus: 1,
      name: "UpComing",
    },
    {
      rstatus: 2,
      name: "Live",
    },
    {
      rstatus: 3,
      name: "Result",
    },
  ];

  const gameContestType = [
    {
      gamekey: "",
      name: "--Select Match--",
    },
    {
      gamekey: "mplycont",
      name: "Match Contest",
    },
    {
      gamekey: "splycont",
      name: "Series Contest",
    },
    {
      gamekey: "plyacc",
      name: "Player Accumulator",
    },
    {
      gamekey: "tmacc",
      name: "Team Accumulator",
    },
    {
      gamekey: "pzpool",
      name: "Prize Pool Contest",
    },
  ];

  const country = [
    {
      id: "+91",
      name: "India",
      code: "IN",
    },
    {
      id: "+44",
      name: "UK",
      code: "UK",
    },
  ];

  const reportType = [
    {
      keys: "user_wallet",
      name: "User Wallet",
    },
    {
      keys: "transaction",
      name: "Transactions",
    },
    {
      keys: "account_statement",
      name: "Account Statement",
    },
    {
      keys: "match_data",
      name: "Match Data",
    },
  ];

  const userStatusArray = [
    {
      statusKey: "bal_add",
      name: "Add Balance",
    },
    {
      statusKey: "bal_add_pen",
      name: "Add Balance Pending",
    },
    {
      statusKey: "bal_fail",
      name: "Transaction Failed",
    },
    {
      statusKey: "bal_wtd_req",
      name: "Withdrawal Request Pending",
    },
    {
      statusKey: "bal_wtd_req_succ",
      name: "Withdrawal Request Accepted",
    },
    {
      statusKey: "bal_wtd_req_decln",
      name: "Withdrawal Request Decline",
    },
    {
      statusKey: "win",
      name: "Winning Amount",
    },
    {
      statusKey: "re_win",
      name: "Winning Amount",
    },
    {
      statusKey: "wel_bns",
      name: "Welcome Bonus",
    },
    {
      statusKey: "cancel_bal",
      name: "Cancel deposit",
    },
    {
      statusKey: "cancel_bns",
      name: "Cancel bonus",
    },
    {
      statusKey: "cancel_win",
      name: "Cancel win",
    },
    {
      statusKey: "revert_win",
      name: "Revert Winning",
    },
    {
      statusKey: "refer_bns",
      name: "Refer Bonus",
    },
    {
      statusKey: "join_bal",
      name: "Join from Deposit",
    },
    {
      statusKey: "join_bns",
      name: "Join from Bonus",
    },
    {
      statusKey: "join_win",
      name: "Join from Winning",
    },
    {
      statusKey: "bal_wtd_tds",
      name: "TDS Deduct",
    },
    {
      statusKey: "bal_wtd_tds_decln",
      name: "TDS Request Decline",
    },
    {
      statusKey: "bal_wtd_tds_succ",
      name: "TDS Request Accepted",
    },
    {
      statusKey: "bal_wtd_tds_pen",
      name: "TDS Request Pending",
    },
    {
      statusKey: "add_amt_bonus",
      name: "Add amount bonus",
    },
    {
      statusKey: "add_amt_gst",
      name: "Add amount GST",
    },
  ];
  // first drop down on chage game type
  const [getGameType, setGameType] = useState(gameType[0]);
  const [reportTypeValue, setReportTypeValue] = useState(reportType[0]);
  const [reportTypeSubmit, setReportTypeSubmit] = useState("user_wallet");
  const [multiUser, setMultiUser] = useState();
  const { loading, report_download_files } = useSelector((state) => state.reports);

  const onChangeGameType = (_, values) => {
    setGameType(values || gameType[0]);
  };

  console.log("get Game Type", getGameType);
  // third drop down select match status
  const [getMatchStatus, setMatchStatus] = useState(match_status[0]);
  const onChangeMatchStatus = (_, values) => {
    setMatchStatus(values || match_status[0]);
  };

  useEffect(() => {
    let dataMatch = { game_type: getGameType.type, rstatus: getMatchStatus.rstatus };
    dispatch(getMatchList(1, 10, dataMatch));
    let data = { type: reportTypeSubmit };
    dispatch(getReportData(page, rowsPerPage, data));
  }, [dispatch, getGameType, getMatchStatus]);

  const [getMatchListName, setMatchListName] = useState();
  const onChangeMatchList = (_, values) => {
    setMatchListName(values?.match_id || "");
  };
  console.log("match id is ", getMatchListName);
  const [getGameContestType, setGameContestType] = useState(gameContestType[0]);
  const onChangeGameContestType = (_, values) => {
    setGameContestType(values || gameContestType[0]);
  };
  console.log("game contest type is ", getGameContestType);
  const [getCountry, setCountry] = useState("");
  const onChangCountry = (_, values) => {
    setCountry(values?.id || "");
  };

  console.log("country is", getCountry);
  const [getTransStatus, setTransStatus] = useState([userStatusArray[0]]);
  const onChangUserStatus = (event, values) => {
    console.log("values---->>", values);
    setTransStatus(values);
  };

  const onChangType = (event, values) => {
    setReportTypeValue(values);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    getReportAllDetail(page, parseInt(event.target.value));
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
    getReportAllDetail(newPage, rowsPerPage);
  };

  useEffect(() => {
    dispatch(GetUserListAction(1, 10));
  }, [dispatch]);

  const fetchRequestData = () => {
    let strTransStatus = "";
    getTransStatus.map((x, i) => {
      strTransStatus = strTransStatus + (i === 0 ? "" : ",") + x.statusKey;
    });

    console.log("startDate,endDate--->>>", startDate, endDate);
    return {
      type: reportTypeValue.keys,
      multiUser,
      gameType: getGameType.type,
      gameKey: getGameContestType.gamekey,
      match_id: getMatchListName,
      start_date: startDate,
      end_date: endDate,
      trans_status: strTransStatus,
      country: getCountry,
    };
  };

  const getReportAllDetail = (pageno, perpage) => {
    //setReportTypeSubmit(reportTypeValue);
    const data = fetchRequestData();
    dispatch(getReportData(pageno, perpage, data));
  };

  const onClickSubmit = (e) => {
    e.preventDefault();
    getReportAllDetail(page, rowsPerPage);
  };

  const onChangeUserList = (event, values) => {
    console.log(
      "e===>>",
      event,
      values.map((x) => x.email)
    );
    let emailList = values.map((x) => x.id);
    emailList = emailList.toString();
    setMultiUser(emailList);
  };

  const onChangeText = (e) => {
    console.log("ee--->>", e.target.value);
    if (e.target.value && e.target.value.length > 2) {
      let data = { match_name: e.target.value, rstatus: getMatchStatus.rstatus, game_type: getGameType.type };
      dispatch(getMatchList(1, 10, data));
    }
  };

  const onChangeUserText = (e) => {
    if (e.target.value && e.target.value.length > 2) {
      let searchname = e.target.value;
      dispatch(dispatch(GetUserListAction(1, 10, "", {}, searchname)));
    }
  };

  let listView = reportList?.report_list?.data?.header ? reportList?.report_list?.data?.header : [];

  let strTransStatus = "";
  getTransStatus.map((x, i) => {
    strTransStatus = strTransStatus + (i === 0 ? "" : ",") + x.statusKey;
  });

  let strQuery = "";
  let data = {
    type: reportTypeValue.keys,
    multiUser,
    gameType: getGameType.type,
    gameKey: getGameContestType.gamekey,
    match_id: getMatchListName,
    start_date: startDate,
    end_date: endDate,
    trans_status: strTransStatus,
  };
  if (data) {
    Object.keys(data).forEach((item, q) => {
      if (data[item]) {
        strQuery = strQuery + (q !== 0 ? "&&" : "") + item + "=" + data[item];
      }
    });
  }

  const onChangeSDate = (e) => {
    if (e.target.value) {
      setStartDate(e.target.value);
    }
  };

  const onChangeEDate = (e) => {
    if (e.target.value) {
      setEndDate(e.target.value);
    }
  };

  const handleGetDownload = () => {
    dispatch(getReportDownloadFiles());
  };

  useEffect(() => {
    handleGetDownload();
  }, []);

  const handleDeleteAll = () => {
    dispatch(deleteAllFiles());
    setOpenDialog(false);
    setOpen(false);
  };

  const handleDownload = () => {
    dispatch(getReportDownload(fetchRequestData()));
    if (!report_download_files?.length) {
      handleGetDownload();
    }
    setTimeout(() => {
      handleGetDownload();
    }, 10 * 1000);
  };

  console.log("User sTatus is", getTransStatus);
  return (
    <Page title="Report Management">
      {loading ? <Loader /> : null}
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Download Report"
          links={[
            {
              name: "Dashboard",
              href: "/dashboard/app",
            },
          ]}
        />
        <Card
          sx={{
            py: 5,
            px: 3,
          }}
        >
          <FormikProvider value={formik}>
            <Form autoComplete="off" onSubmit={onClickSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <Autocomplete
                      sinlge
                      id="tags-outlined"
                      defaultValue={reportTypeValue}
                      options={reportType}
                      getOptionLabel={(option) => option.name}
                      onChange={onChangType}
                      disableClearable
                      filterSelectedOptions
                      renderInput={(params) => {
                        if (params) {
                          params1 = params;
                        }
                        return <TextField {...params} label="Select Report Type" placeholder="Select Report Type" />;
                      }}
                    />
                  </FormControl>
                </Grid>

                {reportTypeValue.keys === "match_data" && (
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <Autocomplete
                        sinlge
                        id="tags-outlined"
                        defaultValue={getGameType}
                        options={gameType}
                        getOptionLabel={(option) => option.name}
                        onChange={onChangeGameType}
                        filterSelectedOptions
                        renderInput={(params) => {
                          if (params) {
                            params1 = params;
                          }
                          return <TextField {...params} label="Select Match" placeholder="Select Match" />;
                        }}
                      />
                    </FormControl>
                  </Grid>
                )}

                {reportTypeValue.keys === "match_data" && (
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <Autocomplete
                        sinlge
                        id="tags-outlined"
                        defaultValue={getMatchStatus}
                        options={match_status}
                        getOptionLabel={(option) => option.name}
                        onChange={onChangeMatchStatus}
                        filterSelectedOptions
                        renderInput={(params) => {
                          if (params) {
                            params1 = params;
                          }
                          return <TextField {...params} label="Select Match Status" placeholder="Select Match Status" />;
                        }}
                      />
                    </FormControl>
                  </Grid>
                )}

                {reportTypeValue.keys === "match_data" && (
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <Autocomplete
                        sinlge
                        id="tags-outlined"
                        options={MatchListData}
                        getOptionLabel={(option) => option.title + ", " + option.date_start_ist}
                        onChange={onChangeMatchList}
                        filterSelectedOptions
                        renderInput={(params) => {
                          if (params) {
                            params1 = params;
                          }
                          return <TextField {...params} label="Select Match List" placeholder="Select Match Name List" onChange={onChangeText} />;
                        }}
                      />
                    </FormControl>
                  </Grid>
                )}

                {(reportTypeValue.keys === "match_data" || reportTypeValue.keys === "transaction") && (
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <Autocomplete
                        sinlge
                        id="tags-outlined"
                        defaultValue={getGameContestType}
                        options={gameContestType}
                        getOptionLabel={(option) => option.name}
                        onChange={onChangeGameContestType}
                        filterSelectedOptions
                        renderInput={(params) => {
                          if (params) {
                            params1 = params;
                          }
                          return <TextField {...params} label="Select Game" placeholder="Select Game" />;
                        }}
                      />
                    </FormControl>
                  </Grid>
                )}

                {reportTypeValue.keys !== "match_data" && reportTypeValue.keys !== "account_statement" && (
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <Autocomplete
                        sinlge
                        id="tags-outlined"
                        options={country}
                        getOptionLabel={(option) => option.name}
                        onChange={onChangCountry}
                        clearOnEscape
                        filterSelectedOptions
                        renderInput={(params) => {
                          if (params) {
                            params1 = params;
                          }
                          return <TextField {...params} label="Select Country" placeholder="Select Country" />;
                        }}
                      />
                    </FormControl>
                  </Grid>
                )}

                {reportTypeValue.keys === "transaction" && (
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        id="tags-outlined"
                        defaultValue={getTransStatus}
                        options={userStatusArray}
                        getOptionLabel={(option) => option.name}
                        onChange={onChangUserStatus}
                        filterSelectedOptions
                        renderInput={(params) => {
                          if (params) {
                            params1 = params;
                          }
                          return <TextField {...params} label="Select Trans. Status" placeholder="Select Trans. Status" />;
                        }}
                      />
                    </FormControl>
                  </Grid>
                )}

                {reportTypeValue.keys !== "account_statement" && (
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel id="access-module-select" shrink>
                        Users
                      </InputLabel>
                      <Autocomplete
                        multiple
                        id="tags-outlined"
                        options={USERLIST}
                        getOptionLabel={(option) => option.email}
                        //defaultValue={[USERLIST[13]]}
                        filterSelectedOptions
                        onChange={onChangeUserList}
                        renderInput={(params) => {
                          if (params) {
                            params1 = params;
                          }

                          return <TextField {...params} label="Users" placeholder="Users" onChange={onChangeUserText} />;
                        }}
                      />
                    </FormControl>
                  </Grid>
                )}

                {reportTypeValue.keys === "account_statement" && (
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel id="access-module-select" shrink>
                        Start Date
                      </InputLabel>
                      <TextField
                        fullWidth
                        type="date"
                        placeholder="Start Date"
                        {...getFieldProps("startdate")}
                        value={startDate}
                        error={Boolean(touched.startdate && errors.startdate)}
                        helperText={touched.startdate && errors.startdate}
                        onChange={onChangeSDate}
                      />
                    </FormControl>
                  </Grid>
                )}
                {reportTypeValue.keys === "account_statement" && (
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel id="access-module-select" shrink>
                        End Date
                      </InputLabel>
                      <TextField
                        fullWidth
                        type="date"
                        placeholder="End Date"
                        {...getFieldProps("enddate")}
                        value={endDate}
                        error={Boolean(touched.enddate && errors.enddate)}
                        helperText={touched.enddate && errors.enddate}
                        onChange={onChangeEDate}
                      />
                    </FormControl>
                  </Grid>
                )}

                <Grid item xs={6}>
                  <LoadingButton type="submit" variant="contained" loading={false}>
                    Submit
                  </LoadingButton>
                </Grid>

                <Grid item xs={6}>
                  <Container sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: "10px" }}>
                    <Button onClick={() => handleDownload()} variant="contained">
                      <Download />
                      Download
                    </Button>
                    {report_download_files && report_download_files?.length ? (
                      <Button
                        variant="outlined"
                        onClick={() => {
                          handleGetDownload();
                          setOpen(true);
                        }}
                      >
                        View Available Downloads
                      </Button>
                    ) : (
                      <></>
                    )}
                  </Container>

                  <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
                    <Box display="flex" justifyContent="space-between" alignItems="center" px={3} py={2}>
                      <DialogTitle sx={{ margin: 0, padding: 0 }}>Download History</DialogTitle>

                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => setOpenDialog(true)}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <Delete /> Delete All Files
                      </Button>
                    </Box>
                    <DialogContent>
                      <List>
                        {report_download_files &&
                          report_download_files.map((file, index) => (
                            <ListItem key={file._id} divider={index !== report_download_files.length - 1}>
                              <ListItemText
                                primary={file.fileName}
                                secondary={
                                  <>
                                    <Typography variant="body2" color="textSecondary">
                                      Size: {formatFileSize(file.fileSize)} | Date: {moment(file.createdAt).format("DD MMM YYYY, hh:mm A")}
                                    </Typography>
                                  </>
                                }
                              />
                              <ListItemSecondaryAction>
                                <Button variant="contained" color="primary" onClick={() => dispatch(downloadReportFile(file._id, file.fileName))}>
                                  Download
                                </Button>
                              </ListItemSecondaryAction>
                            </ListItem>
                          ))}
                      </List>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setOpen(false)} color="secondary">
                        Close
                      </Button>
                    </DialogActions>
                  </Dialog>

                  {/* Confirmation Dialog */}
                  <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
                    <DialogTitle>Confirm Deletion</DialogTitle>
                    <DialogContent>
                      <p>Are you sure you want to delete all report files? This action cannot be undone.</p>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
                      <Button onClick={handleDeleteAll} color="secondary">
                        Delete
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </Card>
        <Card>
          {/* <UserListToolbar
                        numSelected={selected.length}
                        filterName={filterName}
                        onFilterName={handleFilterByName}
                        placeholder="Search user..."
                    /> */}
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={listView}
                  rowCount={reportList?.report_list?.data?.total_count ? reportList?.report_list?.data?.total_count : 0}
                  numSelected={selected.length}
                  // onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {(reportList?.report_list?.data?.userList ? reportList?.report_list?.data?.userList : []).map((data, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          {page * rowsPerPage + (index + 1)}.
                        </TableCell>
                        {listView.map(
                          (item, index) =>
                            item.id !== "c_no" && (
                              <TableCell key={index} align="left">
                                {" "}
                                {item.id !== "status" && typeof data[item.id] === "number" ? (
                                  data[item.id] === 0 ? (
                                    0
                                  ) : (
                                    data[item.id].toFixed(2)
                                  )
                                ) : item.id === "atype" ? (
                                  transDescrip[data[item.id]]
                                ) : item.c == 2 ? (
                                  data[item.c1]?.[item.c2]
                                ) : item.id === "status" ? (
                                  data[item.c1] === 1 ? (
                                    <Label variant="ghost" color="success">
                                      Active
                                    </Label>
                                  ) : (
                                    <Label variant="ghost" color="error">
                                      Inactive
                                    </Label>
                                  )
                                ) : item.id === "gstamt" ? (
                                  ((data["amount"] * 18) / 100).toFixed(2)
                                ) : (
                                  data[item.c1]
                                )}{" "}
                              </TableCell>
                            )
                        )}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 150, 200]}
            component="div"
            count={reportList?.report_list?.data?.total_count || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </Page>
  );
}
